import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestCIReports } from '../../../store/cir-manager/ClinicalIncidentActions';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import Moment from '../../../components/utils/Moment';
import { hashHistory } from 'react-router';
import { hostTitle } from '../../../config/ui';
import { isExecutive } from '../../../store/current-user/CurrentUserSelectors';

class ClinicalIncidentReportManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filter: '',
      selectedOption: -1,
      type: '',
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ selectedOption: event.target.value });
    var filter = null;
    if (event.target.value === "1") {
      filter = 'created-by-me' ;
    }
    if (event.target.value === "2") {
      filter = 'open';
    }
    if (event.target.value === "3") {
      filter = 'closed';
    }
    if (event.target.value === "4") {
      filter = 'all';
    }
    this.setState({ filter: filter }, () => this.table.fireFetchData());
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getCIReports({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: this.state.filter,
        tenantId: this.props.tenantId,
        showValue: this.state.selectedOption,
        type: this.state.type,
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  addReport = (id, mode) => {
    hashHistory.push(`/cir-manager/report/${id}/${mode}`);
  };

  editReport = (id, mode) => {
    hashHistory.push(`/cir-manager/report/${id}/${mode}`);
  };

  assignedToMe() {
    this.setState({ type: 'assigned' }, () => this.table.fireFetchData());
  }

  createdByMe() {
    this.setState({ type: 'created' }, () => this.table.fireFetchData());
  }

  showAll() {
    this.setState({ type: 'all' }, () => this.table.fireFetchData());
  }

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  render() {
    const { data, isExecutive } = this.props;

    return (
      <div id="content">
        <Helmet title={`Clinical Occurrence Reports – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Clinical Occurrence Report', 'Clinical Occurrence Reports']}
              icon="fa fa-fw fa-tasks"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Clinical Occurrences</h2>
                  <div className="widget-toolbar">
                    <button disabled={isExecutive}
                      className="btn btn-primary "
                      onClick={() => this.addReport(0, 'Add')}
                    >
                      Report an Occurrence
                    </button>
                  </div>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <div
                      style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}
                    >
                      <div className="form-inline">
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="status"
                            value={this.state.selectedOption}
                            onChange={this.handleChange}
                          >
                            <option value="-1">Select</option>
                            <option value="1">Created By Me</option>
                            <option value="2">Show Open</option>
                            <option value="3">Show Closed</option>
                            <option value="4">Show All</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isCIRLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[{
                        Header: '',
                        id: 'actions',
                        width: 65,
                        sortable: false,
                        Cell: (row) => (
                          <span>
                            <button disabled={isExecutive}
                              className="btn btn-default btn-xs"
                              onClick={() =>
                                this.editReport(row.original.id, 'Edit')
                              }
                            >
                              <i className="fa fa-pencil" />
                            </button>
                          </span>
                        ),
                      },
                        {
                          Header: 'Id',
                          id: 'id',
                          accessor: 'id',
                        },
                        {
                          Header: 'Occurrence Date',
                          accessor: 'occurrenceAtDate',
                          Cell: (row) => (
                            <Moment
                              date={row.original.occurrenceAtDate}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Type of Individual',
                          accessor: 'individualImpactedType.name',
                        },
                        {
                          Header: 'Client',
                          accessor: 'clientName',
                        },
                        {
                          Header: 'Location',
                          accessor: 'locationName',
                        },
                        {
                          Header: 'COM',
                          accessor: 'COManagerName',
                          sortable: false,
                        },
                        {
                          Header: 'Created By',
                          accessor: 'createdByName',
                          sortable: false,
                        },
                        {
                          Header: 'Status',
                          accessor: 'status.name',
                        },
                        {
                          Header: 'Last Update',
                          accessor: 'lastUpdateAt',
                          Cell: (row) => (
                            <Moment
                              date={row.original.lastUpdateAt}
                              format="MM/DD/YYYY HH:mm"
                            />
                          ),
                        },
                      ]}
                      sortable={true}
                      defaultSorted={[
                        {
                          id: 'occurrenceAtDate',
                          desc: true,
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                      //filterable
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.cirmanager,
    tenantId: state.currentUser.queryParams.tenantId,
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getCIReports: (params) => dispatch(requestCIReports(params)),
  }),
)(ClinicalIncidentReportManager);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/ClinicalIncidentReportManager.js